import { render, staticRenderFns } from "./button-grey.vue?vue&type=template&id=462503b8&"
import script from "./button-grey.vue?vue&type=script&lang=ts&"
export * from "./button-grey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports